<template>
  <div>
    <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100%;
        top: 0px;
      "
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
      class="d-none d-sm-flex"
    >
      <div style="width: 100%" class="mt-5 m-0">
        <h3 class="text-center text-white m-0">Detail Student</h3>
        <br /><br />
      </div>
    </div>
    <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100%;
        top: 0px;
      "
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
      class="d-flex d-sm-none"
    >
      <div style="width: 100%" class="mt-3">
        <CCol sm="12">
          <span @click="GoToPageNotification()">
            <!-- <CIcon name="cil-envelope-closed" class="float-right mr-3" /> -->
            <br />
            <img
              src="../assets/img/iconInboxTeacher.png"
              width="40px"
              class="float-right mr-2 mt-2"
            />
          </span>

          <span class="mt-5 mb-5"> </span>
          <br /><br />
          <br /><br />
          <br /><br />
          <br /><br />
        </CCol>
      </div>
    </div>
    <CCard class="custom-card h-100">
      <CRow>
        <CCol sm="12" class="justify-content-center m-0">
          <CContainer>
            <CCol sm="12" lg="12" class="custom-margin">
              <CRow>
                <h5
                  class="text-left mt-4 d-flex d-sm-none text-black bold"
                  style="font-size:24px"
                >
                  Create Schedule <br />
                </h5>

                <div
                  class="mx-auto d-flex justify-content-center col-12 ml-1 mt-1"
                >
                  <CCard class="p-2 d-none d-sm-flex">
                    <CCol sm="12" lg="12">
                      <CRow>
                        <CCol sm="12" lg="12" class="float-right">
                          <CRow>
                            <CCol sm="9" lg="9">
                              Class
                              <CBadge color="primary">{{
                                findTutor.SubjectName
                              }}</CBadge>
                              <br />
                              <CRow>
                                <CCol sm="3" lg="3">
                                  <strong>Language </strong></CCol
                                >
                                <CCol sm="9" lg="9">
                                  : {{ findTutor.Language }}
                                </CCol>

                                <CCol sm="3" lg="3">
                                  <strong>Session </strong>
                                </CCol>
                                <CCol sm="9" lg="9">
                                  : {{ findTutor.Language }}
                                </CCol>

                                <CCol sm="3" lg="3"
                                  ><strong> Time </strong>
                                </CCol>
                                <CCol sm="9" lg="9">
                                  : {{ findTutor.Language }}
                                </CCol>
                                <CCol sm="3" lg="3">
                                  <strong>Package </strong></CCol
                                >
                                <CCol sm="9" lg="9">
                                  : {{ findTutor.Language }}
                                </CCol>
                                <CCol sm="3" lg="3">
                                  <strong>Start Time </strong></CCol
                                >

                                <CCol sm="9" lg="9">
                                  <CInput
                                    type="datetime-local"
                                    v-model="StartTime"
                                  />
                                </CCol>

                                <CCol sm="3" lg="3">
                                  <strong>End Time </strong></CCol
                                >

                                <CCol sm="9" lg="9">
                                  <CInput
                                    type="datetime-local"
                                    v-model="EndTime"
                                  />
                                </CCol>
                              </CRow>

                              <br />
                            </CCol>
                            <CCol sm="3" lg="3">
                              <strong class="mt-5">
                                <i>{{ findTutor.CreatedTime }}</i></strong
                              >
                            </CCol>
                          </CRow>
                        </CCol>
                      </CRow>
                    </CCol>
                    <CButton
                      color="success"
                      class="custom-btn"
                      size="lg"
                      block
                      @click="InsertSchedule"
                      >Agree</CButton
                    >
                  </CCard>
                  <div class="p-0">
                    <CCol
                      sm="10"
                      lg="10"
                      class="mx-auto d-flex justify-content-center"
                    >
                      <CRow>
                        <CCol sm="12" lg="12" class="p-2">
                          <CRow>
                            <CCol sm="8" lg="8">
                              <CRow class="d-flex d-sm-none">
                                <CCol sm="2" lg="4">
                                  <span class="mt-2 float-left"
                                    ><strong
                                      >Please create a schedule</strong
                                    ></span
                                  >
                                  <span class="mt-2 center float-right">
                                    <strong>
                                      {{ findTutor.CreatedTime }}
                                    </strong></span
                                  >
                                </CCol>
                                <CCol sm="12" class="mt-4">
                                  <strong>Class </strong> :
                                  <CBadge color="primary">{{
                                    findTutor.SubjectName
                                  }}</CBadge>
                                </CCol>
                                <CCol sm="12" class="mt-2">
                                  <strong>Subject </strong> :
                                  {{ findTutor.SubjectName }}
                                </CCol>
                                <CCol sm="12" class="mt-2">
                                  <strong>Language </strong> :
                                  {{ findTutor.Language }}
                                </CCol>
                                <CCol sm="12" class="mt-2">
                                  <strong>Session </strong> :
                                  {{ findTutor.Session }}
                                </CCol>
                                <CCol sm="12" class="mt-2">
                                  <strong>Time </strong> :
                                  {{ findTutor.Time }}
                                </CCol>
                                <CCol sm="12" class="mt-2">
                                  <strong>Package </strong> :
                                  {{ findTutor.PackageName }}
                                </CCol>
                                <CCol sm="12" class="mt-2">
                                  <strong>Start Time </strong> :
                                  <CInput
                                    class="mt-3"
                                    style="
                                    border: 5px solid #D3D3D3;
                                    border-radius: 5px;
                                    "
                                    type="datetime-local"
                                    v-model="StartTime"
                                /></CCol>
                                <CCol sm="12" lg="12">
                                  <!-- <CButton
                                    color="success"
                                    class="custom-btn mt-4 mb-3"
                                    size="lg"
                                    block
                                    @click="InsertSchedule"
                                    >SUBMIT</CButton
                                  > -->
                                  <!-- Apply Job 1 to 1 -->
                                <div v-if="findTutor.PackageName === 'Group of 2'">
                                  <CButton
                                    color="success"
                                    class="custom-btn mt-4 mb-3"
                                    size="lg"
                                    block
                                    @click="TeacherCreateSchedule"
                                    >SUBMIT SCHEDULE
                                  </CButton>
                                </div>

                              <!-- Apply Job Group -->
                              <div v-else>
                                <CButton
                                    color="success"
                                    class="custom-btn mt-4 mb-3"
                                    size="lg"
                                    block
                                    @click="InsertSchedule"
                                    >SUBMIT
                                </CButton>
                              </div>
                                </CCol>
                              </CRow>
                            </CCol>
                          </CRow>
                        </CCol>
                      </CRow>
                    </CCol>
                  </div>
                </div>
              </CRow>
            </CCol>
          </CContainer>
        </CCol>
      </CRow>
    </CCard>
    <CModal title="Success" size="sm" color="success" :show.sync="successModal">
      <CCol sm="12" class="text-center">
        <div class="text-center">
          <img class="m-0" width="100px" src="../assets/img/iconsuccess.png" />
        </div>
      </CCol>

      <h3 class="text-center">SUCCESS !</h3>
      <CCol sm="12">
        <label class="text-center m-0"
          >You have successfully create subject and package</label
        >
      </CCol>
    </CModal>
  </div>
</template>


<script>
import { ThirdPartyDraggable } from "@fullcalendar/interaction";
import backgroundBanner from "../assets/img/bgApps.jpg";

import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import backgroundUrl from "../assets/img/bgLogin.png";
import backgroundUrlTemplate from "../assets/img/bg.png";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
import _ from "lodash";
export default {
  name: "Login",
  data() {
    return {
      backgroundBanner,
      findTutor: {},
      confirmStatus: {},
      successModal: false,
      StartTime: "",
      accept: {},
    };
  },
  async mounted() {
    await this.GetConfirmationClassStatus();
    await this.GetConfirmationClass();
    await this.GetFTDetails();
  },
  methods: {
    async GetConfirmationClassStatus() {
      this.$API
        .get(
          this.$ConfirmationClassStatus + "?notiId=" + this.$route.query.notiId,
          {
            withCredentials: true
          }
        )
        .then(response => {
          if (response.status == 200 && response.data != null) {
            this.confirmStatus = response.data;
            if (this.confirmStatus.scheduleNotiId > 0) {
              this.GoToPageStatus();
            } else {
            }
          }
        });
    },

     async GetConfirmationClass() {
      this.$API
        .get(
          this.$NotifyStudentTutorResponse +
            "?notiId=" +
            this.$route.query.notiId,
          {
            withCredentials: true
          }
        )
        .then(response => {
          if (response.status == 200 && response.data != null) {
            this.accept = response.data;
            this.userId = this.accept.UserId;
          }
        });
    },

    InsertSchedule() {
      this.$dialog
        .alert({
          title: "Notification Send",
          body:
            "You have choose a tutor. A notification have been send to notify the tutor. Please wait for a response.",
          icon: "info"
        })
        .then(function(dialog) {
          console.log("Closed");
        });
      this.GotoScheduleStatus();
      const formData = new FormData();

      formData.append("FindTutorId", this.findTutor.FindTutorId);
      formData.append("StartTime", this.StartTime);

      return this.$API
        .post(this.$SetSchedule, formData, {
          withCredentials: true
        })
        .then(response => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            // this.successModal = true;
            // this.GoToPageNotification();
          }
        })
        .catch(error => {
          if (error.response) {
            this.Busy = false;
            this.Error = true;
            console.log(error.response.status);
          }
        });
    },
    TeacherCreateSchedule() {
      this.$dialog
        .alert({
          title: "Notification Send",
          body:
            "You have choose a tutor. A notification have been send to notify the tutor. Please wait for a response.",
          icon: "info"
        })
        .then(function(dialog) {
          console.log("Closed");
        });
      this.GotoScheduleStatus();
      const formData = new FormData();

      formData.append("FindTutorId", this.accept.FindTutorId);
      formData.append("AcceptJobId", this.accept.AcceptJobId);
      formData.append("StudentId", this.accept.StudentId);
      formData.append("TeacherId", this.accept.TeacherId);
      formData.append("StartTime", this.StartTime);

      return this.$API
        .post(this.$TeacherCreateSchedule, formData, {
          withCredentials: true
        })
        .then(response => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
          }
        })
        .catch(error => {
          if (error.response) {
            this.Busy = false;
            this.Error = true;
            console.log(error.response.status);
          }
        });
    },
    async GetFTDetails() {
      this.$API
        .get(this.$GetFindTutorDetail + "?notiId=" + this.$route.query.notiId, {
          withCredentials: true
        })
        .then(response => {
          console.log("masuk");
          console.log(response.data);
          console.log(this.$route.query.notiId);
          console.log(response.status);
          if (response.status == 200 && response.data != null) {
            this.findTutor = response.data;
            console.log(this.findTutor);
          }
        });
    },
    GoToPageNotification() {
      this.$router.push("/NotificationTeacher?userId=" + this.profile.ToUserId);
    },
    GotoScheduleStatus() {
      this.$router.push(
        "/StudentScheduleStatus?notiId=" + this.$route.query.notiId
      );
    },
    GoToPageStatus() {
      this.$router.push("/TeacherStatus?notiId=" + this.$route.query.notiId);
    }
  }
};
</script>
